import { TKey } from "@/app/translations/TKey";

export const WHY_FRAGMENTS: TKey[] = [
  TKey.HOME_MEIDLY_WHY_FRAGMENT_1,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_2,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_3,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_4,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_5,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_6,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_7,
  TKey.HOME_MEIDLY_WHY_FRAGMENT_8,
];
